<template>
  <div class="content">
    <Modal v-model="showModal" title="题目配置" @on-ok="confirm" @on-cancel="cancel" :loading="$root.$children[0].modalLoading" width="1243" class="top">
      <div class="test-wrap" ref="testRef">
        <div class="title">
          <div>题目配置</div>
          <div>操作</div>
        </div>
        <div v-for="(item, index) in testList" :key="index">
          <div class="content title-box">
            <div class="title-wrap">题目{{ index + 1 }}</div>
            <div class="input-wrap">
              <Input
                v-model="item.title"
                :disabled="!canEdit"
                type="textarea"
                placeholder="请输入..."
                :autosize="true"
                @on-blur="
                  event => {
                    item.title = event.target.value.trim();
                  }
                "
              />
            </div>
            <div class="type-wrap">
              <RadioGroup v-model="item.isChooseMore" size="default">
                <Radio label="0" :disabled="!canEdit">单项选题</Radio>
                <Radio label="1" :disabled="!canEdit">多项选题</Radio>
              </RadioGroup>
            </div>
            <div class="action-wrap">
              <span :class="canEdit ? '' : 'disabled'" @click="canEdit && addTest(index)">新增题目</span>
              <span :class="canEdit ? '' : 'disabled'" @click="canEdit && addOptions(index)">新增选项</span>
              <span @click="showRemarkPopup(item)">考题解析</span>
              <span :class="canEdit ? '' : 'disabled'" v-if="testList.length > 1" @click="canEdit && testList.length > 1 && delTest(index)">删除题目</span>
            </div>
          </div>
          <div v-for="(sub, idx) in item.options" :key="idx" class="content">
            <div class="title-wrap">选项{{ letters[idx] }}</div>
            <div class="input-wrap">
              <Input
                v-model="sub.content"
                :disabled="!canEdit"
                type="textarea"
                placeholder="请输入..."
                @on-blur="
                  event => {
                    sub.content = event.target.value.trim();
                  }
                "
                :autosize="true"
              />
            </div>
            <div class="type-wrap">
              <RadioGroup v-model="sub.isTrue" size="default">
                <Radio label="1" :disabled="!canEdit">正确答案</Radio>
                <Radio label="0" :disabled="!canEdit">错误答案</Radio>
              </RadioGroup>
            </div>
            <div class="action-wrap">
              <!-- <span v-if="item.options.length > 1" @click="addOptions(index,idx)">新增选项</span> -->
              <span :class="canEdit ? '' : 'disabled'" v-if="item.options.length > 1" @click="canEdit && delOptions(index, idx)">删除选项</span>
            </div>
          </div>
        </div>
      </div>
    </Modal>
    <Modal v-model="showRemark" title="考题解析" @on-ok="canEdit && save" @on-cancel="canEdit && reset" width="800">
      <div class="remark-wrap">
        <Input v-model="sel.content" :disabled="!canEdit" type="textarea" placeholder="输入考题解析内容" />
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      canEdit: true,
      sel: {},
      selRemark: '',
      letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'],
      testList: [
        {
          title: '', //选项标题
          testId: '', //课程id
          isChooseMore: '0', //0-单选1-多选
          orderNum: 0,
          remark: '',
          type: 2, // 题目类型 1-课后作业 2-考试试题  3-问卷课程中心 默认写死 =2
          options: [
            {
              title: 'A',
              orderNum: 0,
              content: '',
              isTrue: '0' //0 错误  1正确
            }
          ]
        }
      ], //题目列表
      showModal: false,
      isUpload: false,
      showRemark: false,
      testId: '' //课程id
    };
  },
  created() {},
  methods: {
    save() {
      this.showRemark = false;
    },
    reset() {
      this.sel.content = this.selRemark;
    },
    showRemarkPopup(item) {
      this.sel = item;
      this.selRemark = item.content;
      this.showRemark = true;
    },
    delTest(index) {
      this.testList.splice(index, 1);
    },
    delOptions(index, idx) {
      this.testList[index].options.splice(idx, 1);
    },
    addOptions(index, idx) {
      let data = {
        title: 'A',
        orderNum: 0,
        content: '',
        isTrue: '0' //0 错误  1正确
      };
      if (idx != undefined) {
        this.testList[index].options.splice(idx + 1, 0, data);
      } else {
        this.testList[index].options.push(data);
      }
      let scrollHeight = this.$refs.testRef.scrollHeight;
      this.$nextTick(() => {
        this.$refs.testRef.scrollTo(0, scrollHeight);
      });
    },
    addTest(index) {
      let data = {
        title: '', //选项标题
        testId: this.testId, //课程id
        isChooseMore: '0', //0-单选1-多选
        orderNum: 0,
        remark: '',
        type: 2, // 题目类型 1-课后作业 2-考试试题  3-问卷课程中心 默认写死 =2
        options: [
          {
            title: 'A',
            orderNum: 0,
            content: '',
            isTrue: '0' //0 错误  1正确
          }
        ]
      };
      this.testList.splice(index + 1, 0, data);
      let scrollHeight = this.$refs.testRef.scrollHeight;
      this.$nextTick(() => {
        this.$refs.testRef.scrollTo(0, scrollHeight);
      });
    },
    open(item) {
      if (item.id) {
        this.canEdit = item.useTime ? false : true;
        this.testId = item.id;
        this.getDetail();
      }
      this.showModal = true;
    },
    // 详情
    getDetail() {
      this.$http({
        url: `/buz/testCenter/read/question/detail`,
        type: 'GET',
        data: {
          id: this.testId
        }
      }).then(res => {
        if (res.data && res.data.length) {
          this.testList = res.data.map(item => {
            if (item.options) {
              item.options = JSON.parse(item.options);
            }
            return item;
          });
        } else {
          this.testList = [
            {
              title: '', //选项标题
              testId: '', //课程id
              isChooseMore: '0', //0-单选1-多选
              orderNum: 0,
              remark: '',
              type: 2, // 题目类型 1-课后作业 2-考试试题  3-问卷课程中心 默认写死 =2
              options: [
                {
                  title: 'A',
                  orderNum: 0,
                  content: '',
                  isTrue: '0' //0 错误  1正确
                }
              ]
            }
          ];
        }
      });
    },
    confirm() {
      if (!this.canEdit) {
        this.showModal = false;
        return;
      }
      let isEmpty = false;
      let errMsg = '';
      this.$units.notCloseModal(this);
      let allEmpty = true;
      if (this.testList.length == 1) {
        this.testList.forEach(item => {
          if (item.title) allEmpty = false;
          if (item.options) {
            item.options.forEach((sub, idx) => {
              if (sub.content) allEmpty = false;
            });
          }
        });
      } else {
        allEmpty = false;
      }
      if (!allEmpty) {
        this.testList.forEach((item, index) => {
          item.orderNum = index;
          if (!item.title) isEmpty = true;
          let len = item.options.filter(i => i.isTrue == 1).length;
          console.log('len', len);
          if (item.isChooseMore == 0) {
            //单选
            if (len > 1) {
              errMsg = `题目${index + 1}为单项选题，只能有一个正确答案`;
            } else if (len == 0) {
              errMsg = `题目${index + 1}为单项选题，需要设置正确答案`;
            }
          } else if (item.isChooseMore == 1) {
            //多选
            if (len <= 1) {
              errMsg = `题目${index + 1}为多项选题，最少有两个正确答案`;
            }
          }
          if (item.options) {
            item.options.forEach((sub, idx) => {
              sub.orderNum = idx;
              sub.title = this.letters[idx];
              if (!sub.content) isEmpty = true;
            });
          }
        });
        if (errMsg) {
          return this.$notice.error(errMsg);
        }
        if (isEmpty) {
          return this.$notice.error('您还有题目没有填写');
        }
      }
      console.log(this.testList);
      if (allEmpty) {
        this.$notice.inquiry('您还没有配置题目，是否保存？').then(() => {
          this.saveTest({
            testQuestionList: [],
            testId: this.testId
          });
        });
      } else {
        this.saveTest({
          testQuestionList: this.testList,
          testId: this.testId
        });
      }
    },
    saveTest(data) {
      this.$http({
        url: `/buz/testCenter/edit/question`,
        type: 'POST',
        data,
        apiPermissionCode: ''
      }).then(res => {
        this.$Message.success('修改成功');
        this.showModal = false;
        this.$emit('reload');
      });
    },
    cancel() {}
  }
};
</script>
<style lang="scss" scoped>
.disabled {
  cursor: unset !important;
  color: #727c8e !important;
}
/deep/.ivu-modal-body {
  padding: 27px 40px 0 30px;
}

* {
  box-sizing: border-box;
}

.test-wrap {
  border: 1px solid #e9e9e9;
  max-height: 500px;
  overflow: scroll;
  margin-top: 10px;
  .title {
    display: flex;
    border-bottom: 1px solid #e9e9e9;

    > div {
      width: 613px;
      height: 38px;
      background: #f7f7f7;
      border-right: 1px solid #e9e9e9;
      line-height: 38px;
      text-align: center;
      font-size: 14px;
      color: #515c6f;
    }

    & :last-child {
      border-right: none;
      width: 560px;
    }
  }

  .title-box {
    border-top: 4px solid #ddd;
  }
  .content {
    display: flex;
    border-bottom: 1px solid #e9e9e9;

    .title-wrap {
      width: 70px;
      // height: 54px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      background: #f7f7f7;
      // line-height: 54px;
      border-right: 1px solid #e9e9e9;
    }

    .input-wrap {
      padding: 10px;
      width: 542px;
      text-align: center;
      // height: 54px;
      background: #f7f7f7;
      // line-height: 54px;
      border-right: 1px solid #e9e9e9;
    }

    .type-wrap {
      width: 220px;
      // height: 54px;
      line-height: 54px;
      border-right: 1px solid #e9e9e9;
      padding-left: 45px;
    }

    .action-wrap {
      text-align: center;
      flex: 1;

      span {
        line-height: 54px;
        cursor: pointer;
        width: 56px;
        font-size: 14px;
        color: #236dff;
        margin-left: 20px;
      }

      & :first-child {
        margin-left: 0;
      }
    }
  }
}
</style>
